import PelotaBlanca from "../../assets/img/pelota-blanca.svg";
import Nube from "../../assets/img/nube.svg";
import ArrowRight from "../../assets/img/arrow-right.svg";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import X from "../../assets/img/x-lg.svg";
import {
  getDDMMFormat,
  getDDMMHHmmFormat,
  getHHMMFormat,
  parseValidDate,
} from "../../utils/dates";
import { usePartido } from "../../context/PartidoContext";

const EventosCard = ({
  id,
  categoria,
  subcategoria,
  lugar,
  fecha,
  inicioAcreditacion,
  finAcreditacion,
  fechaInicioRespuesta,
  fechaFinalRespuesta,
  nombreEquipo1,
  nombreEquipo2,
  fotoEquipo1,
  fotoEquipo2,
  fotoIconoDeporte,
  nombreEvento,
  isAcreditable,
  inicioAcreditacionFotografo,
  finAcreditacionFotografo,
  fechaInicioRespuestaFotografo,
  fechaFinalRespuestaFotografo,
  isAcreditableFotografo,
  tipoAcreditacion,
  fechaCambioPeriodista,
}) => {
  const navigate = useNavigate();
  const { setSelectedPartido } = usePartido();

  const esFotografo = tipoAcreditacion === "fotografo";

  const fechaDate = new Date(fecha);
  const inicioDate = parseValidDate(esFotografo ? inicioAcreditacionFotografo : inicioAcreditacion);
  const finDate = parseValidDate(esFotografo ? finAcreditacionFotografo : finAcreditacion);
  const inicioRespuestaDate = parseValidDate(esFotografo ? fechaInicioRespuestaFotografo : fechaInicioRespuesta);
  const finRespuestaDate = parseValidDate(esFotografo ? fechaFinalRespuestaFotografo : fechaFinalRespuesta);
  const cambioPeriodistaDate = parseValidDate(fechaCambioPeriodista);

  const acreditableActual = esFotografo ? isAcreditableFotografo : isAcreditable;

  const handleAcreditarse = () => {
    setSelectedPartido({
      id,
      tipoAcreditacion,
      categoria,
      subcategoria,
      fotoEquipo1,
      fotoEquipo2,
      nombreEvento,
      fotoIconoDeporte,
      lugar,
      fecha,
      inicioAcreditacion: esFotografo ? inicioAcreditacionFotografo : inicioAcreditacion,
      finAcreditacion: esFotografo ? finAcreditacionFotografo : finAcreditacion,
    });
    navigate("/login");
  };

  return (
    <div className="partidos-card">
      <div className="pcat">
        <img src={PelotaBlanca} alt="" />
        <div className="d-flex align-items-center">
          <span>{categoria}</span>
          <div className="vline"></div>
          <p>{subcategoria}</p>
        </div>
      </div>
      {fotoEquipo1 && fotoEquipo2 ? (
        <div className="equipos">
          <img src={fotoEquipo1} alt={nombreEquipo1} />
          <span>VS</span>
          <img src={fotoEquipo2} alt={nombreEquipo2} />
        </div>
      ) : (
        <div className="equipos">
          <img src={fotoIconoDeporte} alt="" className="foto-icono-deporte" />
        </div>
      )}
      <div className="info">
        <h4 translate="no">{nombreEvento}</h4>
        <p>{lugar}</p>
        <p>
          {getDDMMFormat(fechaDate)} | {getHHMMFormat(fechaDate)}hs
        </p>
      </div>
      <div className="acreditaciones">
        <div className="d-flex">
          <img src={Nube} alt="" />
          <p>Acreditaciones</p>
        </div>
        <div>
          {inicioDate && (
            <span style={{ display: "block" }}>
              COMIENZO -{">"} {getDDMMHHmmFormat(inicioDate)}
            </span>
          )}
          {finDate && (
            <span style={{ display: "block" }}>
              FIN -{">"} {getDDMMHHmmFormat(finDate)}
            </span>
          )}
          {inicioRespuestaDate && (
            <span style={{ display: "block" }}>
              FECHA INICIO RESPUESTA -{">"} {getDDMMHHmmFormat(inicioRespuestaDate)}
            </span>
          )}
          {finRespuestaDate && (
            <span style={{ display: "block" }}>
              FECHA FIN RESPUESTA -{">"} {getDDMMHHmmFormat(finRespuestaDate)}
            </span>
          )}
          {!esFotografo && cambioPeriodistaDate && (
            <span style={{ display: "block" }}>
              CAMBIO PERIODISTA -{">"} {getDDMMHHmmFormat(cambioPeriodistaDate)}
            </span>
          )}
        </div>
      </div>
      <div className="pos-rel">
        {acreditableActual ? (
          <Button
            variant={`partido-btn ${window.innerWidth < 768 ? "active" : ""}`}
            onClick={handleAcreditarse}
          >
            <span>Comenzar acreditacion</span>
            <img src={ArrowRight} alt="" />
          </Button>
        ) : (
          <Button
            variant={`partido-btn ${window.innerWidth < 768 ? "active" : ""} disabled`}
            isDisabled
          >
            <span>Comenzar acreditacion</span>
            <img src={X} alt="" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default EventosCard;
